import React from 'react';
import { Icon } from './Icon.js';
export const IconShorts = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 8L11.5 4H12.5L14 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.5 20L13 12.5H11L9.5 20H3L4.5 4H12H19.5L21 20H14.5Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconShorts.js.map